export default __webpack_public_path__ + "static/media/adyali.b5d62bcc.png";